import React from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';

const isServer = typeof window === 'undefined';
const TEST_DOMAINS = ['eroplay-test.me', 'eroplay-dev.me'];

const MetaManager = () => {
  const location = useLocation();
  const origin = isServer ? 'https://eroplay.ai' : window.location.origin;

  const getCanonicalUrl = () => {
    const path = location.pathname;
    const segments = path.split('/').filter(Boolean);

    if (segments.length >= 2) {
      const [firstSegment, secondSegment] = segments;

      if (firstSegment === 'tag' && secondSegment) {
        return `${origin}/tag/${secondSegment}`;
      }

      if (firstSegment === 'roleplay' && secondSegment) {
        return `${origin}/roleplay/${secondSegment}`;
      }
    }

    return origin;
  };

  const canonicalUrl = getCanonicalUrl();
  const isTestDomain = !isServer && TEST_DOMAINS.includes(window.location.hostname);
  const isProd = import.meta.env.PROD && !isTestDomain;

  const metaTags = [
    <link key="canonical" rel="canonical" href={canonicalUrl} />,
    <link key="shortcut-icon" rel="shortcut icon" href="/fav_ero.webp" />,
    <link key="icon-any" rel="icon" href="/fav_ero.webp" sizes="any" />,
    <link key="favicon" rel="icon" type="image/webp" href="/fav_ero.webp" />,
    <link key="favicon-alt" rel="icon" type="image/x-icon" href="/fav_ero.webp" />,
    <link key="favicon-preload" rel="preload" as="image" type="image/webp" href="/fav_ero.webp" />,
    <link key="favicon-png" rel="icon" type="image/png" href="/fav_ero.png" />,
    <link key="apple-touch-icon" rel="apple-touch-icon" href="/fav_ero.webp" />,
    <meta key="viewport" name="viewport" content="width=device-width, initial-scale=1.0" />,
    <meta key="charset" charset="utf-8" />,
    <title key="title">EroPlay.ai — Unleash your fantasies with AI roleplay</title>,
    <meta
      key="description"
      content="More than just sexting. Dive into the erotic scenes of your dreams, interacting with virtual characters, each having their own personalities, traits, and goals, just like real people. Alongside engaging text responses, immerse yourself further with periodic images that vividly depict the unfolding scenarios. The storyline setup is defined, but how the story unfolds is in your hands — your words and actions shape the story, reflecting the unpredictability of real life.In this world, you have total freedom. Be anyone, do anything, and explore your fantasies without any limits!"
      name="description" />
  ];


  if (!isProd) {
    metaTags.push(
      <meta key="googlebot" name="googlebot" content="noindex, nofollow" />
    );
  }

  return (
    <Helmet>
      {metaTags}
      {/* Hotjar */}
      <script type="text/javascript">{`
        try {
          (function(h,o,t,j,a,r){
            h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
            h._hjSettings={hjid:5107393,hjsv:6};
            a=o.getElementsByTagName('head')[0];
            r=o.createElement('script');r.async=1;
            r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
            a.appendChild(r);
          })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
        } catch(exc) {}
      `}</script>

      {/* Google Analytics */}
      <script async src="https://www.googletagmanager.com/gtag/js?id=AW-16691672461"></script>
      <script type="text/javascript">{`
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', 'AW-16691672461');
      `}</script>

      {/* Yandex.Metrika */}
      <script type="text/javascript">{`
        (function(m,e,t,r,i,k,a){
          m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
          m[i].l=1*new Date();
          for(var j=0;j<document.scripts.length;j++){if(document.scripts[j].src===r){return;}}
          k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)
        })(window,document,'script','https://mc.yandex.ru/metrika/tag.js','ym');
        ym(97113455, 'init', {
          clickmap:true,
          trackLinks:true,
          accurateTrackBounce:true,
          webvisor:true
        });
      `}</script>

      {/* Twitter (X) Pixel */}
      <script type="text/javascript">{`
        if (window.location.hostname === 'erogination.com') {
          !function(e,t,n,s,u,a){
            e.twq||(s=e.twq=function(){
              s.exe?s.exe.apply(s,arguments):s.queue.push(arguments);
            },s.version='1.1',s.queue=[],u=t.createElement(n),u.async=!0,u.src='https://static.ads-twitter.com/uwt.js',
            a=t.getElementsByTagName(n)[0],a.parentNode.insertBefore(u,a))
          }(window,document,'script');
          twq('config','oraqq');
          twq('event','tw-oraqq-oraqr',{
            currency: null,
            conversion_id: null,
            email_address: null,
            phone_number: null
          });
        }
      `}</script>
    </Helmet>
  );
};

export default MetaManager; 